var apiUrl = window.appConfig.apiUrl;
var auth0Config = window.appConfig.auth0Config;
export default {
  apiUrl: apiUrl,
  auth0Config: auth0Config
};